import { ProductScheme } from '@/apis/rest/generated/types'
import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import { ProductTypeDefinedByFrontend } from '@/types/product-type-defined-by.frontend'

interface ClickBestSellerTabV2EventParams {
  tabName: string
  product: ProductTypeDefinedByFrontend
  location: string
}
export const useBestEventTracker = () => {
  const { triggerCustomEvent } = useTracker()

  const trackClickBestSellerTabEvent = (tabName?: string) => {
    triggerCustomEvent(FitpetMallEventEnum.ClickBestSellerTab, {
      tabName,
    })
  }

  const trackClickBestSellerProductEvent = (tabName: string, product?: ProductScheme) => {
    triggerCustomEvent(FitpetMallEventEnum.ClickBestSellerProduct, {
      tabName,
      productId: product?.id,
      productName: product?.name,
      productPrice: product?.defaultOption.salePrice,
      productDiscountRate: product?.discountRate,
      productPurchasePrice: product?.salePrice,
      productReviewAvgScore: product?.review.score,
      productReviewCount: product?.review.count,
    })
  }

  const trackClickBestSellerProductEventV2 = ({ tabName, product, location }: ClickBestSellerTabV2EventParams) => {
    triggerCustomEvent(FitpetMallEventEnum.ClickBestSellerProduct, {
      tabName,
      location,
      productId: product?.id,
      productName: product?.name,
      productPrice: product?.price,
      productDiscountRate: product?.discountRate,
      productPurchasePrice: product?.salePrice,
      productReviewAvgScore: product?.reviewScore,
      productReviewCount: product?.reviewCount,
      is_shownprice_coupondiscounted: product?.hasApplicableProductCoupon,
    })
  }

  const trackHomeWeeklyBestSellerProductEvent = (tabName?: string) => {
    triggerCustomEvent(FitpetMallEventEnum.ClickHomeWeeklyBestTab, {
      tabName,
    })
  }

  return {
    trackClickBestSellerTabEvent,
    trackClickBestSellerProductEvent,
    trackHomeWeeklyBestSellerProductEvent,
    trackClickBestSellerProductEventV2,
  }
}
